import React, { useState } from "react";
import Navigation from "./components/Navigation";
import ResumeForm from "./components/ResumeForm";
import ProfileManager from "./components/ProfileManager/ProfileManager";
import History from "./components/History/History";
import ExportImport from "./components/ExportImport/ExportImport";
import Footer from "./components/Footer";
import "./styles/ResumeForm.css";

function App() {
    const [activeTab, setActiveTab] = useState('profile');

    const renderContent = () => {
        switch (activeTab) {
            case 'profile':
                return <ProfileManager />;
            case 'generate':
                return <ResumeForm />;
            case 'history':
                return <History />;
            case 'export':
                return <ExportImport />;
            default:
                return <ProfileManager />;
        }
    };

    return (
        <div className="app">
            <header className="app-header">
                <div className="header-content">
                    <div className="logo-container">
                        <div className="logo-placeholder">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="8" fill="url(#gradient)"/>
                                <path d="M12 14H28M12 20H28M12 26H22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                                <defs>
                                    <linearGradient id="gradient" x1="0" y1="0" x2="40" y2="40">
                                        <stop offset="0%" stopColor="#6366f1"/>
                                        <stop offset="100%" stopColor="#8b5cf6"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <h1 className="app-title">منشئ السيرة الذاتية</h1>
                    </div>
                    <p className="app-subtitle">أنشئ سير ذاتية احترافية ومحسّنة لأنظمة التوظيف</p>
                </div>
            </header>

            <Navigation activeTab={activeTab} onTabChange={setActiveTab} />

            <main className="main-content">
                <div className="container">
                    {renderContent()}
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default App;